var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235,
    height: 200,
    viewBox: "0 0 235 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.901 8.34832C158.901 8.34832 126.939 48.8338 75.8003 24.6849C24.6616 0.536034 -26.4774 65.88 17.5589 105.655C61.5952 145.429 18.5024 167.285 48.4188 191.662C82.4209 219.368 112.024 163.186 139.014 175.971C198.582 204.187 242.712 193.017 232.768 160.345C215.313 102.993 192.994 99.2628 210.04 69.4313C227.085 39.5998 189.465 -22.4256 158.901 8.34832Z",
    fill: "#2A2D3B",
    fillOpacity: 0.46
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.982 94.8855V179.823L51.0352 151.339L51.3497 66.7083L116.982 94.8855Z",
    fill: "#3D425B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.983 94.9363V179.874L182.61 152.374V66.9792L116.983 94.9363Z",
    fill: "#36394B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M116.982 94.8854L182.93 67.2636L117.5 38.2606L51.0352 66.5731L116.982 94.8854Z",
    fill: "#6836C2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0259 81.725L99.3931 113.939C99.5715 114.026 99.7733 114.051 99.9676 114.012C100.162 113.973 100.338 113.871 100.469 113.721L116.982 94.8853L51.035 66.573L32.8782 80.1869C32.7541 80.2799 32.6559 80.4034 32.5932 80.5453C32.5306 80.6873 32.5054 80.843 32.5203 80.9974C32.5351 81.1519 32.5894 81.2999 32.6779 81.4273C32.7665 81.5548 32.8863 81.6573 33.0259 81.725V81.725Z",
    fill: "#813EFB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M182.929 67.2635L201.245 83.8223C201.356 83.9233 201.441 84.0506 201.491 84.1927C201.541 84.3348 201.555 84.4871 201.532 84.6359C201.508 84.7847 201.448 84.9252 201.356 85.0447C201.264 85.1642 201.144 85.259 201.007 85.3203L135.458 114.575C135.283 114.653 135.087 114.673 134.9 114.633C134.712 114.593 134.543 114.495 134.415 114.352L116.982 94.8854L182.929 67.2635Z",
    fill: "#813EFB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M117.5 38.2605L183.113 67.2635L192.549 65.0764C192.734 65.0334 192.902 64.9329 193.027 64.7894C193.152 64.6458 193.229 64.4664 193.246 64.2767C193.263 64.087 193.22 63.8967 193.123 63.7329C193.026 63.5692 192.879 63.4402 192.704 63.3645L132.792 37.4044C132.661 37.3476 132.518 37.3226 132.376 37.3316L117.5 38.2605Z",
    fill: "#813EFB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M117.5 38.2605L52.2549 66.7081L44.0071 65.3221C43.8161 65.2865 43.6417 65.1903 43.5096 65.0479C43.3775 64.9055 43.2947 64.7244 43.2735 64.5313C43.2523 64.3382 43.2938 64.1434 43.3918 63.9757C43.4899 63.808 43.6393 63.6763 43.8179 63.6001L105.211 37.1419C105.347 37.0842 105.495 37.0605 105.642 37.0729L117.5 38.2605Z",
    fill: "#813EFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no_data.99239ab0ef7794effb3f38ea276fefe7.svg";
export { ForwardRef as ReactComponent };